"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetStrategyValuesShortList = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const get_strategy_values_short_list_query_1 = require("./get-strategy-values-short-list.query");
const apollo_client_utils_1 = require("../../../../apollo-client/apollo-client.utils");
const client_constants_1 = require("../../../client/client.constants");
const client_utils_1 = require("../../../client/client.utils");
const hooks_1 = require("../../../client/hooks");
const values_utils_1 = require("../../../client/values/values.utils");
const getValuesConnection = (data) => { var _a, _b, _c, _d, _e; return ((_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.labelValidation) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.node) === null || _e === void 0 ? void 0 : _e.values); };
const edgesToMenuOptions = (data) => { var _a, _b, _c; return ((_c = (_b = (_a = getValuesConnection(data)) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map(({ node }) => ({ label: node.value, value: node.value }))) !== null && _c !== void 0 ? _c : []); };
const updateQuery = (prev, { fetchMoreResult }) => {
    if (!fetchMoreResult)
        return prev;
    const prevValues = getValuesConnection(prev);
    const newValues = getValuesConnection(fetchMoreResult);
    if (!newValues || !prevValues)
        return fetchMoreResult;
    return Object.assign(Object.assign({}, fetchMoreResult), { productTreeNode: Object.assign(Object.assign({}, fetchMoreResult.productTreeNode), { labelValidation: Object.assign(Object.assign({}, fetchMoreResult.productTreeNode.labelValidation), { edges: fetchMoreResult.productTreeNode.labelValidation.edges.map((edge) => {
                    var _a, _b;
                    return (Object.assign(Object.assign({}, edge), { node: Object.assign(Object.assign({}, edge.node), { values: Object.assign(Object.assign({}, newValues), { edges: [...((_a = prevValues.edges) !== null && _a !== void 0 ? _a : []), ...((_b = newValues.edges) !== null && _b !== void 0 ? _b : [])] }) }) }));
                }) }) }) });
};
const fetchMoreOptions = { updateQuery };
const useGetStrategyValuesShortList = ({ pageSize = client_constants_1.DEFAULT_FILTER_PAGE_SIZE, sortingItem, options: queryOptions, productTreeNodeId, }) => {
    var _a, _b;
    const sort = values_utils_1.sortingItemToStrategyValuesSortMap[sortingItem];
    const activeAttributeIdRef = (0, react_1.useRef)('');
    const searchAbortControllerRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => () => {
        var _a;
        (_a = searchAbortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
    }, []);
    const [executeQuery, { data, networkStatus, fetchMore, variables, }] = (0, react_2.useLazyQuery)(get_strategy_values_short_list_query_1.GET_STRATEGY_VALUES_SHORT_LIST, {
        fetchPolicy: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy,
        notifyOnNetworkStatusChange: true,
    });
    const pageInfo = (_a = getValuesConnection(data)) === null || _a === void 0 ? void 0 : _a.pageInfo;
    const pagination = (0, hooks_1.usePagination)({
        pageInfo,
        networkStatus,
        pageSize,
        fetchMore,
        fetchMoreOptions,
        lastVariables: variables,
    });
    const loadInitialOptions = (0, react_1.useCallback)((attributeId) => __awaiter(void 0, void 0, void 0, function* () {
        activeAttributeIdRef.current = attributeId;
        searchAbortControllerRef.current = undefined;
        try {
            const response = yield executeQuery({
                variables: {
                    label: attributeId, productTreeNodeId, sort, first: pageSize, after: undefined, filter: undefined,
                },
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(response);
            return edgesToMenuOptions(response.data);
        }
        catch (error) {
            return [];
        }
    }), [productTreeNodeId, executeQuery, pageSize, sort]);
    const loadMoreOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        yield pagination.onNextPage();
    }), [pagination]);
    const onSearch = (0, react_1.useCallback)((searchText) => {
        var _a;
        const attributeId = activeAttributeIdRef.current;
        if (!attributeId)
            return;
        (_a = searchAbortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        searchAbortControllerRef.current = new AbortController();
        const filter = searchText
            ? { some: { value: { contains: searchText, mode: graphql_1.StringFilterMode.Insensitive } } }
            : undefined;
        executeQuery({
            variables: {
                label: attributeId,
                productTreeNodeId,
                sort,
                first: pageSize,
                after: undefined,
                filter,
            },
            context: {
                fetchOptions: { signal: searchAbortControllerRef.current.signal },
            },
        }).catch((error) => {
            if (!(0, apollo_client_utils_1.isAbortError)(error)) {
                // Apollo exposes non-abort failures through query state for this lazy loader.
            }
        });
    }, [executeQuery, productTreeNodeId, pageSize, sort]);
    const options = (0, react_1.useMemo)(() => edgesToMenuOptions(data), [data]);
    const isLoading = (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus);
    return {
        /** @deprecated Use loadInitialOptions instead for incremental loading */
        getStrategyValuesShortList: loadInitialOptions,
        loadInitialOptions,
        loadMoreOptions,
        onSearch,
        options,
        hasNextPage: (_b = pagination.hasNextPage) !== null && _b !== void 0 ? _b : false,
        moreItemsLoading: pagination.isLoadingMore,
        isLoading,
        data,
    };
};
exports.useGetStrategyValuesShortList = useGetStrategyValuesShortList;
